import React from 'react'
import CollectionMainPage from "../page/CollectionMainPage"


function EARRINGSPage({categoryType}) {
  return (
    <CollectionMainPage categoryType={categoryType}/>
  )
}

export default EARRINGSPage